import Header from '../components/Header';
import TermsPolicy from '../components/TermsPolicy';
import Faq from '../components/Faq';
import Footer from '../components/Footer';
import usePageSeo from '../hooks/usePageSeo';
import { PAGE_SEO } from '../config/seo';

function TermsPolicyPage() {
  usePageSeo(PAGE_SEO.termsPolicy);
  
  return (
    <>
      <Header />
      <TermsPolicy />
      <Faq />
      <Footer />
    </>
  );
}

export default TermsPolicyPage;
